package com.devsusana.portfolio.i18n

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.localStorage
import kotlinx.browser.window

private const val LANGUAGE_STORAGE_KEY = "devsusana:language"

/**
 * Global reactive state for application internationalization.
 * Persists the user's choice to localStorage and initializes with browser preference.
 */
object LanguageState {
    var currentLanguage by mutableStateOf(loadInitialLanguage())
        private set

    private fun loadInitialLanguage(): AppLanguage {
        try {
            val saved = localStorage.getItem(LANGUAGE_STORAGE_KEY)
            if (saved == "es") return AppLanguage.ES
            if (saved == "en") return AppLanguage.EN

            // Fallback to browser language
            val browserLang = window.navigator.language.lowercase()
            if (browserLang.startsWith("es")) return AppLanguage.ES
        } catch (_: Throwable) {
            // Safe fallback during pre-rendering or SSR
        }
        return AppLanguage.EN
    }

    fun setLanguage(lang: AppLanguage) {
        currentLanguage = lang
        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, lang.code)
        } catch (_: Throwable) {
            // Ignore during pre-rendering
        }
    }

    fun toggle() {
        setLanguage(currentLanguage.opposite())
    }
}
